<template>
  <span class="admin-dropdown-container" v-click-outside="clickOutside">
    <AdminDotButton @click="toogleDropdown" />
    <div class="admin-dropdown" v-show="show">
      <button class="admin-dropdown-item" @click="toogleDropdown">
        <img src="/images/icons/copy.svg" alt="" />
        Copy
      </button>
      <button
        class="admin-dropdown-item br-top"
        @click="toogleDropdown"
        :disabled="checkDisabled()"
      >
        <img src="/images/icons/trash-2.svg" alt="" v-if="!checkDisabled()" />
        <img src="/images/icons/trash-2-off.svg" alt="" v-else />
        Delete
      </button>
    </div>
  </span>
</template>


<script>
import AdminDotButton from "../Button/AdminDotButton.vue";

export default {
  props: {
    state: {
      type: String,
    },
  },
  components: {
    AdminDotButton,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    toogleDropdown() {
      this.show = !this.show;
    },
    checkDisabled() {
      if (this.state == "draft") return false;
      else return true;
    },
    clickOutside() {
      this.show = false;
    },
  },
};
</script>

<style scoped>
button {
  border: none;
  background-color: transparent;
}

.admin-dropdown-container {
  position: relative;
}

.admin-dropdown {
  position: absolute;
  background-color: white;
  border-radius: 4px;
  border: 1px solid rgba(34, 34, 34, 1);
  z-index: 1;
  width: 100px;
}

.admin-dropdown-item {
  padding: 4px 8px;
  cursor: pointer;
  border: none;
  width: 100%;
  text-align: left;
  padding-left: 10px;
}

.admin-dropdown-item:hover {
  background-color: #f2f2f2;
}

.admin-dropdown-item:disabled:hover {
  background-color: white;
}

.admin-dropdown-item:disabled {
  cursor: default;
  color: rgba(190, 192, 194, 1);
}

.br-top {
  border-top: 1px solid rgba(34, 34, 34, 1);
}
</style>
